import { render, staticRenderFns } from "./companyinfo.vue?vue&type=template&id=1b573e02&"
import script from "./companyinfo.vue?vue&type=script&lang=js&"
export * from "./companyinfo.vue?vue&type=script&lang=js&"
import style0 from "./companyinfo.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports